import React from 'react';
import cx from 'clsx';
import { Box, Button, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export type Props = {
  title?: string;
  video?: { src: string; title: string };
  resourceLinks?: { href: string; label: string }[];
  className?: string;
};

const ResourceButton = ({ href, label }: { href: string; label: string }) => {
  const classes = useStyles();

  return (
    <a href={href} className={classes.link} target="_blank" rel="noopener noreferrer">
      <Button variant="contained" color="primary" disableElevation className={classes.button}>
        {label}
      </Button>
    </a>
  );
};

const ResourcesBox = ({ title, video, resourceLinks = [], className }: Props) => {
  const classes = useStyles();

  return (
    <Paper elevation={0} className={cx(classes.root, className)}>
      {title && (
        <Typography align="center" variant="h3">
          {title}
        </Typography>
      )}
      <Box>
        {video && (
          <Box className={classes.videoWrapper}>
            <Box className={classes.videoContainer}>
              <video
                id="video-iframe"
                title={video.title}
                className={classes.videoiFrame}
                src={video.src}
                controls
              />
            </Box>
          </Box>
        )}
        {resourceLinks.length > 0 && (
          <Box className={classes.resourceContainer}>
            {resourceLinks?.map((link, index) => (
              <ResourceButton key={index} href={link.href} label={link.label} />
            ))}
          </Box>
        )}
      </Box>
    </Paper>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#F7FBFF',
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    margin: 'auto'
  },
  link: {
    textDecoration: 'none'
  },
  resourceContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing(2)
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  videoWrapper: {
    width: '100%',
    maxWidth: '650px',
    maxHeight: 'auto',
    margin: '0 auto'
  },
  videoContainer: {
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
    paddingTop: '56.25%'
  },
  videoiFrame: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%'
  }
}));

export default ResourcesBox;
